import styled from "styled-components";

import { errorIcon } from "src/shared/assets";

export const ErrorContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 200px;
  padding: 24px 0;
  text-align: center;
`;

export const ErrorIcon = styled.i`
  background: url(${errorIcon}) no-repeat;
  background-size: contain;
  height: 50px;
  width: 50px;
`;
